import { WorklistTagsConfig } from "../../../types/api/UserInfo";
import servicesUtils from "../../../utils/servicesUtils";

const getEmergencyPatients = (apiParams = {}) => {
  return servicesUtils.postService("/patients/", {
    emergency: true,
    page_size: 30, // exceptionally keeping 30 for emergency patients listing otherwise sohould be constants.PAGE_SIZE,
    ...apiParams,
  });
};

const postWorklistTagConfig = (params: WorklistTagsConfig) => {
  return servicesUtils.postService("profile/worklist_tags_config/", {
    worklist_tags_config: params,
  });
};

export { getEmergencyPatients, postWorklistTagConfig };
